import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  gap: ${theme.spacing(2)};
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.small};
`;

export const qrContainerStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing(3)};
  padding: ${theme.spacing(3, 0)};
`;

export const qrStyle = css`
  border: 1px solid ${theme.colors.neutral20};
  padding: ${theme.spacing(2)};
  border-radius: ${theme.borderRadius.small};
`;
